import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Nav.css";
import menuImage from "../../assets/nav/nav_banner.jpg";

const Nav: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="nav">
      <div className="nav__logo">
        <Link to="/">
          <img
            src="/logo.png"
            alt="Mystique Realm Logo"
            className="nav__logo-img"
          />
        </Link>
      </div>

      <div className="nav__hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
      </div>

      {menuOpen && (
        <div className="nav__menu-overlay">
          <div className="nav__menu-header">
            <div className="nav__logo">
              <Link to="/">
                <img
                  src="/logo.png"
                  alt="Mystique Realm Logo"
                  className="nav__logo-img"
                  id="nav_open_logo"
                />
              </Link>
            </div>
            <div className="nav__hamburger" onClick={() => setMenuOpen(false)}>
              <h5>MENU</h5>
            </div>
          </div>
          <div className="nav__menu-content">
            <div className="nav__links">
              <div className="nav__main-links">
                <Link to="/" onClick={() => setMenuOpen(false)}>
                  HOME
                </Link>
                {/* <Link to="/explore" onClick={() => setMenuOpen(false)}>
                  EXPLORE
                </Link> */}
                <Link to="/about" onClick={() => setMenuOpen(false)}>
                  ABOUT US
                </Link>
                <Link to="/faqs" onClick={() => setMenuOpen(false)}>
                  FAQS
                </Link>
                <Link to="/contact" onClick={() => setMenuOpen(false)}>
                  CONTACT US
                </Link>
                <Link to="/packages" onClick={() => setMenuOpen(false)}>
                  PACKAGES
                </Link>
              </div>
              <div className="social-links">
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  INSTAGRAM
                </a>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  FACEBOOK
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  TWITTER
                </a>
              </div>
            </div>
            <div className="nav__menu-image">
              <img src={menuImage} alt="Menu background" />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Nav;
